import animateScroll from 'scrollto-with-animation'

export const scrollTo = (pos, duration = 600, delay = 0) => new Promise(resolve => {
  setTimeout(() => {
    animateScroll(document.documentElement, 'scrollTop', pos, duration, 'easeInOutSine', resolve)
  }, delay)
})
export const kebabify = (words) =>
  words
    .toLowerCase()
    .replace(' ', '-')

export const prettyDate = (date) => {
  // return date;
  let rtn = new Date(date.replace(/\s/, 'T'));
  // let rtn = new Date(date).toString().split(' ').slice(0, 4).join(' ').replace(/( \d+)$/, ',$1')
  return dateToString(rtn);
}
export const dateToString = (date, char = '/', type = 1) => {
  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  if (day < 10) day = '0' + day.toString();
  if (month < 10) month = '0' + month.toString();
  if (type === 1) {
    return day.toString() + char + month.toString() + char + year.toString();
  } else {
    return year.toString() + char + month.toString() + char + day.toString();
  }
}
export const axios = require('axios');



// WEBPACK FOOTER //
// ./src/helpers.js